// Year end period actions
//import actionType
import {
  GET_YEAR_END_PERIOD_LIST,
  GET_YEAR_END_PERIOD_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_LIST_FAILURE,
  GET_YEAR_END_PERIOD_DETAILS,
  GET_YEAR_END_PERIOD_DETAILS_SUCCESS,
  GET_YEAR_END_PERIOD_DETAILS_FAILURE,
  UPDATE_YEAR_END_PERIOD_DETAILS,
  UPDATE_YEAR_END_PERIOD_DETAILS_SUCCESS,
  UPDATE_YEAR_END_PERIOD_DETAILS_FAILURE,
  CREATE_YEAR_END_PERIOD,
  CREATE_YEAR_END_PERIOD_SUCCESS,
  CREATE_YEAR_END_PERIOD_FAILURE,
  DELETE_YEAR_END_PERIOD,
  DELETE_YEAR_END_PERIOD_SUCCESS,
  DELETE_YEAR_END_PERIOD_FAILURE,
  GET_YEAR_END_PERIOD_INVOICE_LIST,
  GET_YEAR_END_PERIOD_INVOICE_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_INVOICE_LIST_FAILURE,
  GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST,
  GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_FAILURE,
  GET_YEAR_END_PERIOD_PURCHASE_LIST,
  GET_YEAR_END_PERIOD_PURCHASE_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_PURCHASE_LIST_FAILURE,
  GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST,
  GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_SUCCESS,
  GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_FAILURE,
} from "./actionType";

// Get Year End Period List
export const getYearEndPeriodList = () => ({
  type: GET_YEAR_END_PERIOD_LIST,
});

export const getYearEndPeriodListSuccess = (payload) => ({
  type: GET_YEAR_END_PERIOD_LIST_SUCCESS,
  payload,
});

export const getYearEndPeriodListFailure = (payload) => ({
  type: GET_YEAR_END_PERIOD_LIST_FAILURE,
  payload,
});

// Get Year End Period Details
export const getYearEndPeriodDetails = (payload) => ({
  type: GET_YEAR_END_PERIOD_DETAILS,
  payload,
});

export const getYearEndPeriodDetailsSuccess = (payload) => ({
  type: GET_YEAR_END_PERIOD_DETAILS_SUCCESS,
  payload,
});

export const getYearEndPeriodDetailsFailure = (payload) => ({
  type: GET_YEAR_END_PERIOD_DETAILS_FAILURE,
  payload,
});

// Update Year End Period Details
export const updateYearEndPeriodDetails = (payload) => ({
  type: UPDATE_YEAR_END_PERIOD_DETAILS,
  payload,
});

export const updateYearEndPeriodDetailsSuccess = (payload) => ({
  type: UPDATE_YEAR_END_PERIOD_DETAILS_SUCCESS,
  payload,
});

export const updateYearEndPeriodDetailsFailure = (payload) => ({
  type: UPDATE_YEAR_END_PERIOD_DETAILS_FAILURE,
  payload,
});

// Create Year End Period
export const createYearEndPeriod = (payload) => ({
  type: CREATE_YEAR_END_PERIOD,
  payload,
});

export const createYearEndPeriodSuccess = (payload) => ({
  type: CREATE_YEAR_END_PERIOD_SUCCESS,
  payload,
});

export const createYearEndPeriodFailure = (payload) => ({
  type: CREATE_YEAR_END_PERIOD_FAILURE,
  payload,
});

// Delete Year End Period
export const deleteYearEndPeriod = (payload) => ({
  type: DELETE_YEAR_END_PERIOD,
  payload,
});

export const deleteYearEndPeriodSuccess = (payload) => ({
  type: DELETE_YEAR_END_PERIOD_SUCCESS,
  payload,
});

export const deleteYearEndPeriodFailure = (payload) => ({
  type: DELETE_YEAR_END_PERIOD_FAILURE,
  payload,
});

// Year End Period invoice List
export const getYearEndPeriodInvoiceList = (payload) => ({
  type: GET_YEAR_END_PERIOD_INVOICE_LIST,
  payload,
});

export const getYearEndPeriodInvoiceListSuccess = (payload) => ({
  type: GET_YEAR_END_PERIOD_INVOICE_LIST_SUCCESS,
  payload,
});

export const getYearEndPeriodInvoiceListFailure = (payload) => ({
  type: GET_YEAR_END_PERIOD_INVOICE_LIST_FAILURE,
  payload,
});

// Year End Period Invoice Items List
export const getYearEndPeriodInvoiceItemsList = (payload) => ({
  type: GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST,
  payload,
});

export const getYearEndPeriodInvoiceItemsListSuccess = (payload) => ({
  type: GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_SUCCESS,
  payload,
});

export const getYearEndPeriodInvoiceItemsListFailure = (payload) => ({
  type: GET_YEAR_END_PERIOD_INVOICE_ITEMS_LIST_FAILURE,
  payload,
});

// Year End Period Purchase List
export const getYearEndPeriodPurchaseList = (payload) => ({
  type: GET_YEAR_END_PERIOD_PURCHASE_LIST,
  payload,
});

export const getYearEndPeriodPurchaseListSuccess = (payload) => ({
  type: GET_YEAR_END_PERIOD_PURCHASE_LIST_SUCCESS,
  payload,
});

export const getYearEndPeriodPurchaseListFailure = (payload) => ({
  type: GET_YEAR_END_PERIOD_PURCHASE_LIST_FAILURE,
  payload,
});

// Year End Period Purchase Items List
export const getYearEndPeriodPurchaseItemsList = (payload) => ({
  type: GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST,
  payload,
});

export const getYearEndPeriodPurchaseItemsListSuccess = (payload) => ({
  type: GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_SUCCESS,
  payload,
});

export const getYearEndPeriodPurchaseItemsListFailure = (payload) => ({
  type: GET_YEAR_END_PERIOD_PURCHASE_ITEMS_LIST_FAILURE,
  payload,
});
